import type { TimeInputValue, DateInputValue } from '@doxyme/ui/components';
import dayjs from 'dayjs';

/**
 * Re-interprets local date/time components as UTC so the ISO serialization
 * preserves the values the user actually selected (e.g. Feb 27 stays Feb 27,
 * 3:05 PM stays 15:05) regardless of the browser's timezone offset.
 */
export const toUTCPreservingLocal = (value: Date): Date => {
  return new Date(
    Date.UTC(
      value.getFullYear(),
      value.getMonth(),
      value.getDate(),
      value.getHours(),
      value.getMinutes(),
      value.getSeconds(),
      value.getMilliseconds(),
    ),
  );
};

/**
 * Format date to be used as part of the invitation content in both text and email invited.
 */
export const getFormattedDate = (
  date: DateInputValue,
  locale: string,
): string => {
  return date !== null
    ? `${dayjs(date).locale(locale).format('ddd, MMM D')}`
    : '';
};

/**
 * Format time to be used as part of the invitation content in both text and email invited.
 */
export const getFormattedTime = (time: TimeInputValue): string => {
  if (time !== null) {
    const mins = dayjs(time).minute();
    if (mins === 0) {
      return dayjs(time).format('ha');
    }

    return dayjs(time).format('h:mma');
  }
  return '';
};
